import { find, get } from 'lodash';

export const getToggleFilterActiveItem = (data) =>
  find(data, ({ id }) => id === true);
export const getToggleFilterInactiveItem = (data) =>
  find(data, ({ id }) => id === false);
export const isToggleFilterSelected = (data) =>
  get(getToggleFilterActiveItem(data), 'selected');
export const isToggleFilterDisabled = (data) =>
  get(getToggleFilterActiveItem(data), 'disabled');
export const getMinPrice = (items) =>
  Math.min(...items.map((item) => item.min_price).filter((price) => price > 0));
export const getHotelsCount = (items) =>
  items.reduce((result, item) => result + item.hotel_count, 0);

export const prepareHotelNameFilter = (value = '') => {
  const filteredValue = value.replace(/\+/g, ' ').trim();

  return { value: filteredValue };
};

export const getExploreFiltersForQueryString = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filters: Record<string, any>,
) => {
  const operators = getMultipleChoiceFilterOptions(filters, 'operators');
  const ltExtras = getMultipleChoiceFilterOptions(filters, 'lt_extras');
  const instantConfirm = get(filters, ['instant_confirm', '0', 'selected']);
  const freeCancel = get(filters, ['free_cancel', '0', 'selected']);
  const meals = getMultipleChoiceFilterOptions(filters, 'meals');
  const paymentBenefits = getMultipleChoiceFilterOptions(
    filters,
    'payment_benefits',
  );

  return {
    operators: getSelectedOptionIdsString(operators),
    instantConfirm,
    freeCancel,
    ltExtras: getSelectedOptionIdsString(ltExtras),
    meals: getSelectedOptionIdsString(meals),
    paymentBenefits: getSelectedOptionIdsString(paymentBenefits),
  };
};

export const getMultipleChoiceFilterOptions = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filters: Record<string, any>,
  filterName: string,
) => (Array.isArray(filters[filterName]) ? filters[filterName] : []);

export const getSelectedOptionIds = (
  items: { selected: boolean; id: number }[],
) => items.filter((item) => item.selected).map((item) => item.id);

export const getSelectedOptionIdsString = (
  items: { selected: boolean; id: number }[],
) => getSelectedOptionIds(items).join();
